import { render } from "./CorrectionCellRenderer.vue?vue&type=template&id=2dd2fee6"
import script from "./CorrectionCellRenderer.vue?vue&type=script&lang=js"
export * from "./CorrectionCellRenderer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__